var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.98 96.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 48.49,
    cy: 48.49,
    r: 29.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.42,
    y: 24.23,
    width: 6.15,
    height: 28.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.36,
    y: 47.16,
    width: 21.2,
    height: 5.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.35,
    width: 6.21,
    height: 15.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.35,
    y: 81.84,
    width: 6.21,
    height: 15.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.3,
    y: 42.4,
    width: 6.21,
    height: 15.14,
    transform: "translate(139.38 -39.43) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.47,
    y: 42.4,
    width: 6.21,
    height: 15.14,
    transform: "translate(57.54 42.4) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.32,
    y: 12.89,
    width: 6.21,
    height: 15.14,
    transform: "translate(37.15 -48.75) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.45,
    y: 70.76,
    width: 6.21,
    height: 15.14,
    transform: "translate(61.12 9.11) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.74,
    y: 71.33,
    width: 6.21,
    height: 15.14,
    transform: "translate(186.99 80.36) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.88,
    y: 13.47,
    width: 6.21,
    height: 15.14,
    transform: "translate(47.28 22.49) rotate(135)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.a29c54865d864494e9a51c892b92c801.svg";
export { ForwardRef as ReactComponent };